import Translate from '~/client/shared/i18n/Translate';

type Props = {
  typeTranslateString?: string;
};

const TooltipContent: FC<Props> = ({ typeTranslateString }) => (
  <div id="tournament-type-tooltip">
    <div className="grid gap-1">
      <span className="text-moon-10-caption uppercase text-trunks">
        <Translate id="game-leaderboard.tournament-type" />
      </span>
      <h2 className="text-moon-16 font-semibold text-goten">
        <Translate
          id={`game-leaderboard.${typeTranslateString?.toLowerCase()}`}
        />
      </h2>
      <span className="text-moon-14 font-semibold text-trunks">
        <Translate id={`tournaments.tooltip_desc_${typeTranslateString}`} />
      </span>
    </div>
  </div>
);

export default TooltipContent;
